// =====================================
//	編輯運送方式 modal
//
//	@author: Gray
//	@time 2016 / 09 / 01
// =====================================

window.InifECMobileApp.directive('editDelivery', ['$rootScope', '$ngModal', '$timeout', 'UserService',
	function ($rootScope, $ngModal, $timeout, UserService) {
		var _dir = {};

		var controller = ['$scope', function($scope) {
            // -------------------------------
            // 更改運送資訊
            // -------------------------------
            var submit = function() {

                $scope.isNameEmpty = false;
                $scope.isMobilePhoneEmpty = false;
                $scope.isMobilePhoneError = false;
                $scope.isPostalEmpty = false;
                $scope.isPostalError = false;
                $scope.isAddressEmpty = false;
                $scope.isSenderNameEmpty = false;
                $scope.isSenderMobilePhoneEmpty = false;
                $scope.isSenderMobilePhoneError = false;
                $scope.isSenderPostalEmpty = false;
                $scope.isSenderPostalError = false;
                $scope.isSenderAddressEmpty = false;

                // 檢查收件者地址是否有正確填入
                var isError = false;
                var addressInfo = {};
                if($scope.form.delivery == 1) {

                    if(!$scope.form.name) {
                        $scope.isNameEmpty = true;
                        isError = true;
                    }

                    if(!$scope.form.mobilephone) {
                        $scope.isMobilePhoneEmpty = true;
                        isError = true;
                    }

                    if($scope.form.mobilephone && !isPhone($scope.form.mobilephone)) {
                        $scope.isMobilePhoneError = true;
                        isError = true;
                    }

                    if(!$scope.form.postal) {
                        $scope.isPostalEmpty = true;
                        isError = true;
                    }

                    if($scope.form.postal && isNaN($scope.form.postal)) {
                        $scope.isPostalError = true;
                        isError = true;
                    }

                    if(!$scope.form.address || !$scope.form.newAddress) {
                        $scope.isAddressEmpty = true;
                        isError = true;
                    }

                    addressInfo = {
                        name: $scope.form.name,
                        address: $scope.form.address,
                        postal: $scope.form.postal,
                        phone: $scope.form.phone,
                        mobilephone: $scope.form.mobilephone,
                        phoneExtension: $scope.form.phoneExtension,
                        isSaveAddress: $scope.form.isSaveAddress,
                    }
                }

                var senderInfo = undefined;
                if($scope.form.isConfidentialDelivery) {
                    if(!$scope.form.senderaddress || !$scope.form.sendernewAddress) {
                        $scope.isSenderAddressEmpty = true;
                        isError = true;
                    }

                    if(!$scope.form.sendername) {
                        $scope.isSenderNameEmpty = true;
                        isError = true;
                    }

                    if(!$scope.form.sendermobilephone) {
                        $scope.isSenderMobilePhoneEmpty = true;
                        isError = true;
                    }

                    if($scope.form.sendermobilephone && !isPhone($scope.form.sendermobilephone)) {
                        $scope.isSenderMobilePhoneError = true;
                        isError = true;
                    }

                    if(!$scope.form.senderpostal) {
                        $scope.isSenderPostalEmpty = true;
                        isError = true;
                    }

                    if($scope.form.senderpostal && isNaN($scope.form.senderpostal)) {
                        $scope.isSenderPostalError = true;
                        isError = true;
                    }

                    senderInfo = {
                        sendername: $scope.form.sendername,
                        senderaddress: $scope.form.senderaddress,
                        senderpostal: $scope.form.senderpostal,
                        senderphone: $scope.form.senderphone,
                        sendermobilephone: $scope.form.sendermobilephone,
                        senderphoneExtension: $scope.form.senderphoneExtension,
                        isSaveSenderAddress: $scope.form.isSaveSenderAddress,
                    }
                }

                if(isError) {
                    return;
                }

                var statusResult = {
                    isNameEmpty: $scope.isNameEmpty,
                    isMobilePhoneEmpty: $scope.isMobilePhoneEmpty,
                    isMobilePhoneError: $scope.isMobilePhoneError,
                    isPostalEmpty: $scope.isPostalEmpty,
                    isPostalError: $scope.isPostalError,
                    isAddressEmpty: $scope.isAddressEmpty,
                    isSenderNameEmpty: $scope.isSenderNameEmpty,
                    isSenderMobilePhoneEmpty: $scope.isSenderMobilePhoneEmpty,
                    isSenderMobilePhoneError: $scope.isSenderMobilePhoneError,
                    isSenderPostalEmpty: $scope.isSenderPostalEmpty,
                    isSenderPostalError: $scope.isSenderPostalError,
                    isSenderAddressEmpty: $scope.isSenderAddressEmpty,
                }

                $scope.callback && $scope.callback($scope.form.delivery, addressInfo, $scope.form.isConfidentialDelivery,
                                                    senderInfo, statusResult, $scope.form.shippingFeeInfo);

                closeModal();
            }

            // -------------------------------
            // 更改編輯運送方式
            // -------------------------------
            var changeDelivery = function(delivery, isConfidentialDelivery) {

                $scope.form.delivery = delivery;
                $scope.form.isConfidentialDelivery = isConfidentialDelivery;
            }

            // -------------------------------
            // 從常用地址選擇
            // -------------------------------
            var selectAddress = function() {

                $rootScope.$broadcast('OPEN_SELECT_ADDRESS_MODAL', {
                    callback: function(addressInfo) {

                        if(addressInfo) {
                            $scope.form.postal = addressInfo.postal;
                            $scope.form.address = addressInfo.address;
                            $scope.form.name = addressInfo.name;
                            $scope.form.mobilephone = addressInfo.mobilephone;
                            $scope.form.phone = addressInfo.phone;
                            $scope.form.phoneExtension = addressInfo.phoneExtension;
                            $scope.form.isSaveAddress = false;
                        }
                    }
                })
            }

            // --------------------------------
            // 開啟選取地址modal（寄件人）
            // --------------------------------
            var selectSenderAddress = function() {

                $rootScope.$broadcast('OPEN_SELECT_ADDRESS_MODAL', {
                    callback: function(senderInfo) {
                        if(senderInfo) {
                            $scope.form.senderpostal = senderInfo.postal;
                            $scope.form.senderaddress = senderInfo.address;
                            $scope.form.sendername = senderInfo.name;
                            $scope.form.sendermobilephone = senderInfo.mobilephone;
                            $scope.form.senderphone = senderInfo.phone;
                            $scope.form.senderphoneExtension = senderInfo.phoneExtension;
                            $scope.form.isSaveSenderAddress = false;
                        }
                    }
                })
            }

            // -------------------------------
            // 是否將地址加入最愛
            // -------------------------------
            var toggleSaveAddress = function() {

                $scope.form.isSaveAddress = !$scope.form.isSaveAddress;
            }

            // -------------------------------
            // 是否將寄件地址加入最愛
            // -------------------------------
            var toggleSaveSenderAddress = function() {

                $scope.form.isSaveSenderAddress = !$scope.form.isSaveSenderAddress;
            }

            // -------------------------------
            // 離開編輯運送方式
            // -------------------------------
            var cancel = function() {

                closeModal();
            }

            var addressFromUser = function () {
                $scope.form.postal = $scope.user.postal;
                $scope.form.address = $scope.user.address;
                $scope.form.name = $scope.user.name;
                $scope.form.mobilephone = $scope.user.mobilephone;
                $scope.form.phone = $scope.user.phone;
                $scope.form.phoneExtension = $scope.user.phoneExtension;
                $scope.form.isSaveAddress = false;
            }

            // -------------------------------
            // [private] 開啟 modal
            // -------------------------------
            var openModal = function() {

            	$ngModal.openModal('edit-delivery-modal');
            }

            // -------------------------------
            // [private] 關閉 modal
            // -------------------------------
            var closeModal = function() {

            	$ngModal.closeModal('edit-delivery-modal');
            }

            /*==========================
                Events
            ==========================*/
            $scope.$on('OPEN_EDIT_DELIVERY_MODAL', function(event, data) {
                if(data) {
                    $scope.form.delivery = data.delivery;
                    $scope.form.postal = data.postal;
                    $scope.form.address = data.address;
                    $scope.form.name = data.name;
                    $scope.form.mobilephone = data.mobilephone;
                    $scope.form.phone = data.phone;
                    $scope.form.phoneExtension = data.phoneExtension;
                    $scope.form.isSaveAddress = data.isSaveAddress;

                    $scope.isNameEmpty = data.isNameEmpty;
                    $scope.isMobilePhoneEmpty = data.isMobilePhoneEmpty;
                    $scope.isMobilePhoneError = data.isMobilePhoneError;
                    $scope.isPostalEmpty = data.isPostalEmpty;
                    $scope.isPostalError = data.isPostalError;
                    $scope.isAddressEmpty = data.isAddressEmpty;

                    $scope.form.isConfidentialDelivery = data.isConfidentialDelivery;
                    $scope.form.senderpostal = data.senderpostal;
                    $scope.form.senderaddress = data.senderaddress;
                    $scope.form.sendername = data.sendername;
                    $scope.form.sendermobilephone = data.sendermobilephone;
                    $scope.form.senderphone = data.senderphone;
                    $scope.form.senderphoneExtension = data.senderphoneExtension;
                    $scope.form.isSaveSenderAddress = data.isSaveSenderAddress;

                    $scope.isSenderNameEmpty = data.isSenderNameEmpty;
                    $scope.isSenderMobilePhoneEmpty = data.isSenderMobilePhoneEmpty;
                    $scope.isSenderMobilePhoneError = data.isSenderMobilePhoneError;
                    $scope.isSenderPostalEmpty = data.isSenderPostalEmpty;
                    $scope.isSenderPostalError = data.isSenderPostalError;
                    $scope.isSenderAddressEmpty = data.isSenderAddressEmpty;

                    $scope.isShowSaveButton = data.isShowSaveButton;

                    $scope.callback = data.callback;

                    openModal();
                }
            });

            /*==========================
                Members
            ==========================*/
            $scope.form = {
                delivery: 1,
                postal: '',
                address: '',
                name: '',
                mobilephone: '',
                phone: '',
                phoneExtension: '',
                city: '',
                dist: '',
                newAddress: '',
                shippingFeeInfo: 0,

                senderpostal: '', // 保密代寄寄件人郵遞區號
                senderaddress: '', // 保密代寄寄件人地址
                sendercity: '',
                senderdist: '',
                sendernewAddress: '',
                sendername: '', // 保密代寄寄件人名稱
                sendermobilephone: '', // 保密代寄寄件人手機
                senderphone: '', // 保密代寄寄件人市話
                senderphoneExtension: '', // 保密代寄寄件人分機
                isConfidentialDelivery: false,

                isSaveAddress: false, // 是否將收件資訊加入至常用地址清單
                isSaveSenderAddress: false, // 是否將寄件資訊加入至常用地址清單
            }

            $scope.user = UserService.user
            $scope.isNameEmpty = false;
            $scope.isMobilePhoneEmpty = false;
            $scope.isMobilePhoneError = false;
            $scope.isPostalEmpty = false;
            $scope.isPostalError = false;
            $scope.isAddressEmpty = false;
            $scope.isSenderNameEmpty = false;
            $scope.isSenderMobilePhoneEmpty = false;
            $scope.isSenderMobilePhoneError = false;
            $scope.isSenderPostalEmpty = false;
            $scope.isSenderPostalError = false;
            $scope.isSenderAddressEmpty = false;

            /*==========================
                Methods
            ==========================*/
            $scope.changeDelivery = changeDelivery; // 更改編輯運送方式
            $scope.selectAddress = selectAddress; // 從常用地址選擇
            $scope.selectSenderAddress = selectSenderAddress; // 開啟選取地址modal（寄件人）
            $scope.toggleSaveAddress = toggleSaveAddress; // 是否將地址加入最愛
            $scope.toggleSaveSenderAddress = toggleSaveSenderAddress; // 是否將寄件地址加入最愛
            $scope.submit = submit; // 更改運送資訊
            $scope.cancel = cancel; // 離開編輯運送方式
            $scope.addressFromUser = addressFromUser;
            $scope.callback = undefined;

            /*==========================
                init
            ==========================*/

		}]

		_dir.restrict = "E";
		_dir.scope = true;
		_dir.templateUrl = "mobile/partials/modal/edit_delivery.html";
		_dir.controller = controller;

		return _dir;
	}]
);
